export interface ReactiveFormHostDuplicatePolicyOptions<TModel> {
    readonly model: TModel | null | undefined;
    readonly fieldsToDelete?: readonly string[] | undefined;
    readonly idField?: string | undefined;
    readonly mutate?: boolean | undefined;
}

const defaultIdentifierField = 'id';

/** Applies duplicate-mode model cleanup without coupling the library to application services. */
export class ReactiveFormHostDuplicatePolicy {
    public static apply<TModel>(options: ReactiveFormHostDuplicatePolicyOptions<TModel>): TModel {
        const source = options.model ?? ({} as TModel);
        const target = options.mutate === false
            ? ({ ...(source as Record<string, unknown>) } as TModel)
            : source;
        const writableModel = target as Record<string, unknown>;

        delete writableModel[options.idField ?? defaultIdentifierField];

        for (const field of options.fieldsToDelete ?? []) {
            delete writableModel[field];
        }

        return target;
    }
}
